import React from 'react'
import Link from 'gatsby-link'

const LocationsMenu = ({ lang }) => {
	if (lang === 'es') {
		return (
			<ul className="dropdown locations_menu">

				<ul className="submenu-airports">
					<span>Aeropuertos</span>
					<li>
					
					<Link to='/es/locations/aeropuerto-augusto-sandino'>
					Aeropuerto Augusto Sandino.
					</Link>
				</li>
				</ul>

				<ul className="submenu-city">
					<span>Cuidad</span>

					<li>
					<Link to='/es/locations/oficina-central'>
					Oficina Central
					</Link>
				</li>
				<li>
					<Link to='/es/locations/masaya-aeromundo'>
					Carretera Masaya Aeromundo
					</Link>
				</li>
				<li>
					<Link to='/es/locations/granada'>
					Budget Granada
					</Link>
				</li>

				<li>
					<Link to='/es/locations/matagalpa'>
					Budget Matagalpa
					</Link>
				</li>

				<li>
					<Link to='/es/locations/fontana'>
					Budget Oficina Villa Fontana
					</Link>
				</li>

				<li>
					<Link to='/es/locations/larreynaga'>
					Budget rent a car Larreynaga
					</Link>
				</li>

				<li>
					<Link to='/es/locations/carretera-masaya'>
					Budget rent a car Carretera Masaya Km 12.
					</Link>
				</li>

				<li>
					<Link to='/es/locations/nejapa'>
					Budget Nejapa- Carretera Sur
					</Link>
				</li>

				

				</ul>
				<ul className="submenu-city">
					<span>Hotel</span>

					<li>
					<Link to='/es/locations/holiday-inn'>
					Hotel Holiday Inn Convention Center
					</Link>
				</li>
				<li>
					<Link to='/es/locations/san-juan-del-sur'>
					San Juan del Sur, Hotel Victoriano
					</Link>
				</li>
				<li>
					<Link to='/es/locations/chinandega'>
					Chinandega, Hotel Los Farallones
					</Link>
				</li>
				

				</ul>

			</ul>
		)
	}
	return (
		<ul className="dropdown locations_menu">

				<ul className="submenu-airports">
					<span>Airports</span>
					<li>
					
					<Link to='/en/locations/aeropuerto-augusto-sandino'>
					Augusto Sandino Airport.
					</Link>
				</li>
				</ul>

				<ul className="submenu-city">
					<span>City</span>

					<li>
					<Link to='/en/locations/oficina-central'>
					Central office
					</Link>
				</li>
				<li>
					<Link to='/en/locations/masaya-aeromundo'>
					Masaya Aeromundo Highway
					</Link>
				</li>
				<li>
					<Link to='/en/locations/granada'>
					Budget Granada
					</Link>
				</li>

				<li>
					<Link to='/en/locations/matagalpa'>
				    Budget Matagalpa
					</Link>
				</li>

				<li>
					<Link to='/en/locations/fontana'>
					Budget Oficina Villa Fontana
					</Link>
				</li>

				<li>
					<Link to='/en/locations/larreynaga'>
					Budget rent a car Larreynaga
					</Link>
				</li>

				<li>
					<Link to='/en/locations/carretera-masaya'>
					Budget rent a car Carretera Masaya Km 12.
					</Link>
				</li>

				<li>
					<Link to='/en/locations/nejapa'>
					Budget Nejapa- Carretera Sur
					</Link>
				</li>

				

				</ul>
				<ul className="submenu-city">
					<span>Hotel</span>

					<li>
					<Link to='/en/locations/holiday-inn'>
					Holiday Inn Convention Center Hotel
					</Link>
				</li>
				<li>
					<Link to='/en/locations/san-juan-del-sur'>
					San Juan del Sur, Hotel Victoriano
					</Link>
				</li>
				<li>
					<Link to='/en/locations/chinandega'>
					Chinandega, Hotel Los Farallones
					</Link>
				</li>

				</ul>

				
				
		</ul>
	)
}

export default LocationsMenu



// WEBPACK FOOTER //
// ./src/menus/LocationsMenu.js